
$( document ).ready(function() {
$('.coqproductb #ProductSelect-coqoz3b-option-0>div:first-child label').html('3 Pack<br/><em>(for 1x daily)</em>');
$('.coqproductb #ProductSelect-coqoz3b-option-0>div:last-child label').html('6 Pack<br/><em>(for 2x daily)</em>');
$('.coqproductb #ProductSelect-coqoz3b-option-0>div:last-child').append('<span class="nfs-best-saving">Best Value</span>');
});

$(document).ready(function(){
setTimeout(function(){
      //       $('.rc_label__onetime').html('One-time purchase: <b>$54.00</b>');
      $('.coqproductb #AddToCartForm-coqoz3b .sub_percent').text('(40%)');
      $('.coqproductb #AddToCartForm-coqoz3b .sub_price').text('$54.00');
      $('.coqproductb #AddToCartForm-coqoz3b .sub_percent').attr("id","subpercent");
  $('.coqproductb #AddToCartForm-coqoz4b .sub_percent').attr("id","subpercent");
      $('.coqproductb .sub_percent').removeAttr('id');
      $('.coqproductb #AddToCartForm-coqoz3b .sub_price').removeAttr("data-rtx-subscription-price");
      $('.coqproductb #AddToCartForm-coqoz3b .rtx_strike').removeAttr("data-rtx-onetime-price");
      
      //  $('#AddToCartForm-coqoz3b .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubprice"></div>');
      //  $('#AddToCartForm-coqoz3b .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-price"></div>');
      
      $('.coqproductb #AddToCartForm-coqoz3b .rtx-subscription-label .rtxshotsubprice').text('($2.25 per Dose shot)');
      $('.coqproductb #AddToCartForm-coqoz3b .rtx-subscription-label .rtxshotsubprice').removeClass('rtx-shot-sub-price');
      $('.coqproductb #AddToCartForm-coqoz4b .rtx-subscription-label .rtxshotsubprice').removeClass('rtx-shot-sub-price');
      $('.coqproductb #AddToCartForm-coqoz3b .onetime .rtx-shot-one-price').text('($3.75 per Dose shot)');
      $('.coqproductb #AddToCartForm-coqoz4b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.88 per Dose shot)');
      $('.coqproductb #AddToCartForm-coqoz4b .rtx-subscription>div>label:last-child .onetime .rtxshotsubprice').text('($4.13 per Dose shot)');

 
}, 300);

});
$(document).ready(function(){
setTimeout(function(){
$('.coqproductb .rc_label__deliver_every').after('<p class="nfs-nocomitment">No commitment, cancel anytime</p>');
}, 300);

});

$(".coqproductb #ProductSelect-coqoz3b-option-0>div:first-child").click(function() {
$('.coqproductb #purchaseTypeSubscription-7697614143729---AddToCartForm-coqoz3b').click();
$('.coqproductb .rtx-subscription>div>label:first-child').click();
setTimeout(function(){     
$('.coqproductb #AddToCartForm-coqoz3b .sub_percent').text('(40%)');
$('.coqproductb #AddToCartForm-coqoz3b .sub_price').text('$54.00');
$('.coqproductb .sub_price').removeAttr("data-rtx-subscription-price");
$('.coqproductb #AddToCartForm-coqoz3b .rtx_strike').text('$54.00');
$('.coqproductb #AddToCartForm-coqoz3b .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('.coqproductb #AddToCartForm-coqoz3b .rtx-subscription-label .rtxshotsubprice').text('($2.25 per Dose shot)');
  
$('.coqproductb #AddToCartForm-coqoz3b .onetime .rtx-shot-one-price').text('($3.75 per Dose shot)');
}, 300);
});    

$(".coqproductb #ProductSelect-coqoz3b-option-0>div:last-child").click(function() {
$('.coqproductb #purchaseTypeSubscription-7697614143729---AddToCartForm-coqoz3b').click();
$('.coqproductb .rtx-subscription>div>label:first-child').click();
setTimeout(function(){     
$('.coqproductb #AddToCartForm-coqoz3b .sub_percent').text('(40%)');
$('.coqproductb #AddToCartForm-coqoz3b .sub_price').text('$96.00');
$('.coqproductb .sub_price').removeAttr("data-rtx-subscription-price");
$('.coqproductb #AddToCartForm-coqoz3b .rtx_strike').text('$160.00');
$('.coqproductb #AddToCartForm-coqoz3b .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('.coqproductb #AddToCartForm-coqoz3b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.00 per Dose shot)');
$('.coqproductb #AddToCartForm-coqoz3b .onetime .rtx-shot-one-price').text('($3.33 per Dose shot)');


}, 300);
});




jQuery('.oztabb>span:first-child').click(function() {
    $(this).addClass('active');
    $('.oztabb>span:last-child').removeClass('active');
    $('.coqproductb #AddToCartForm-coqoz3b').show();
    $('.coqproductb #AddToCartForm-coqoz4b').hide();
 
      $('.coqproductb .edumrp').text('$54.00');
    $('.coqproductb .edusp').text('$54.00');
  
  $('.coqproductb .main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/cholesterolImage1.png?v=1739891938");
    $('.coqproductb .main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/cholesterolImage1.png?v=1739891938");

  });

jQuery('.oztabb>span:last-child').click(function() {
      $(this).addClass('active');
      $('.oztabb>span:first-child').removeClass('active');
      $('.coqproductb #AddToCartForm-coqoz3b').hide();
      $('.coqproductb #AddToCartForm-coqoz4b').show();
      $('.coqproductb #AddToCartForm-coqoz4b .sub_percent').text('(40%)');
      $('.coqproductb #AddToCartForm-coqoz4b .sub_price').text('$59.40');
   $('.coqproductb #AddToCartForm-coqoz4b .sub_price').removeAttr("data-rtx-subscription-price");
      $('.coqproductb #AddToCartForm-coqoz4b .rtx_strike').removeAttr("data-rtx-onetime-price");
     
      $('.coqproductb #AddToCartForm-coqoz4b .sub_price').removeClass('sub_price');
      $('.coqproductb #AddToCartForm-coqoz4b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.88 per Dose shot)');
      $('.coqproductb #AddToCartForm-coqoz4b .rtx-subscription>div>label:first-child .rtxshotsubprice').removeClass('rtx-shot-one-price');;
      
      $('.coqproductb #AddToCartForm-coqoz4b .rtx-subscription>div>label:last-child .rtx-shot-one-price').text('($4.13 per Dose shot)');
      $('.coqproductb .edumrp').text('$99.00');
      $('.coqproductb .edusp').text('$59.40');
  $('.coqproductb .main-pr1').attr("src", "https://dosedaily.co/cdn/shop/files/5_8e411cdb-0f35-4683-95f7-15342fa6b664_1800x1800.png?v=1729108402");
     $('.coqproductb .main-pr11').attr("src", "https://dosedaily.co/cdn/shop/files/5_8e411cdb-0f35-4683-95f7-15342fa6b664_1800x1800.png?v=1729108402");

});






 



jQuery('.coqproductb .pr-img1 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.coqproductb .main-pr1').attr('src', thissrc);
jQuery('.coqproductb .pr-img1 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});








           